import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
export const determineDirectionAngle = (lat1, long1, lat2, long2) => {
    const dLat = lat1 - lat2;
    const dLng = long1 - long2;
    let angle = Math.atan2(dLng, dLat) * (180 / Math.PI);
    if (angle < 0) {
        angle = 360 + angle;
    }
    return angle;
};
export function calculateBoundingBox(latitude, longitude, distanceInKm) {
    const latRadian = latitude * (Math.PI / 180);
    const degLatKm = 110.574235;
    const degLongKm = 111.32 * Math.cos(latRadian);
    const deltaLat = distanceInKm / degLatKm;
    const deltaLong = distanceInKm / degLongKm;
    const minLatitude = latitude - deltaLat;
    const minLongitude = longitude - deltaLong;
    const maxLatitude = latitude + deltaLat;
    const maxLongitude = longitude + deltaLong;
    return {
        maxLatitude: maxLatitude,
        maxLongitude: maxLongitude,
        minLatitude: minLatitude,
        minLongitude: minLongitude
    };
}
export function getMinOrMax(markersObj, minOrMax, latitudeOrLongitude) {
    if (!markersObj.length) {
        markersObj = [
            { latitude: 25.599114, longitude: -124.857181 },
            { latitude: 49.930214, longitude: -67.363576 }
        ];
    }
    if (minOrMax == 'max') {
        return maxBy(markersObj, function (value) {
            return value[latitudeOrLongitude];
        })[latitudeOrLongitude];
    }
    else {
        return minBy(markersObj, function (value) {
            return value[latitudeOrLongitude];
        })[latitudeOrLongitude];
    }
}
export function getStopsBounds(stops) {
    const allCoords = stops
        .map((stop) => {
        const coords = stop.warehouse?.address?.coordinates;
        if (coords) {
            return {
                latitude: coords.latitude,
                longitude: coords.longitude
            };
        }
        else {
            return;
        }
    })
        .filter((coords) => coords && coords?.latitude && coords?.longitude);
    const maxLatitude = getMinOrMax(allCoords, 'max', 'latitude');
    const minLatitude = getMinOrMax(allCoords, 'min', 'latitude');
    const maxLongitude = getMinOrMax(allCoords, 'max', 'longitude');
    const minLongitude = getMinOrMax(allCoords, 'min', 'longitude');
    const southWest = [minLongitude, minLatitude];
    const northEast = [maxLongitude, maxLatitude];
    return [southWest, northEast];
}
export const getStopBoundingBox = (stop, distanceInKm = 0.1) => {
    if (!stop?.warehouse?.address?.boundingBox) {
        const stopLatitude = stop?.warehouse?.address?.coordinates?.latitude;
        const stopLongitude = stop?.warehouse?.address?.coordinates?.longitude;
        if (!stopLatitude || !stopLongitude)
            return [];
        const boundingBox = calculateBoundingBox(stopLatitude, stopLongitude, distanceInKm);
        const polygonCoordinates = [
            [
                [boundingBox.minLongitude, boundingBox.minLatitude],
                [boundingBox.maxLongitude, boundingBox.minLatitude],
                [boundingBox.maxLongitude, boundingBox.maxLatitude],
                [boundingBox.minLongitude, boundingBox.maxLatitude],
                [boundingBox.minLongitude, boundingBox.minLatitude]
            ]
        ];
        return polygonCoordinates;
    }
    if (stop?.warehouse?.address?.coordinates?.longitude && stop?.warehouse?.address?.coordinates?.latitude) {
        const stopPoint = [
            stop.warehouse.address.coordinates.longitude,
            stop.warehouse.address.coordinates.latitude
        ];
        const boundingBoxFromAddress = stop.warehouse.address.boundingBox.map(parseFloat);
        const boundingBox = [
            [boundingBoxFromAddress[2], boundingBoxFromAddress[0]],
            [boundingBoxFromAddress[3], boundingBoxFromAddress[1]]
        ];
        const isStopInBoundingBox = isPointInBoundingBox(stopPoint, boundingBox);
        if (isStopInBoundingBox) {
            const expandedBox = {
                maxLatitude: boundingBox[1][1] + 0.001,
                maxLongitude: boundingBox[1][0] + 0.001,
                minLatitude: boundingBox[0][1] - 0.001,
                minLongitude: boundingBox[0][0] - 0.001
            };
            const polygonCoordinates = [
                [
                    [expandedBox.minLongitude, expandedBox.minLatitude],
                    [expandedBox.maxLongitude, expandedBox.minLatitude],
                    [expandedBox.maxLongitude, expandedBox.maxLatitude],
                    [expandedBox.minLongitude, expandedBox.maxLatitude],
                    [expandedBox.minLongitude, expandedBox.minLatitude]
                ]
            ];
            return polygonCoordinates;
        }
        else {
            const allCoords = [
                { latitude: boundingBox[0][1], longitude: boundingBox[0][0] },
                { latitude: boundingBox[1][1], longitude: boundingBox[1][0] },
                { latitude: stopPoint[1], longitude: stopPoint[0] }
            ];
            const maxLatitude = getMinOrMax(allCoords, 'max', 'latitude');
            const minLatitude = getMinOrMax(allCoords, 'min', 'latitude');
            const maxLongitude = getMinOrMax(allCoords, 'max', 'longitude');
            const minLongitude = getMinOrMax(allCoords, 'min', 'longitude');
            const polygonCoordinates = [
                [
                    [minLongitude, minLatitude],
                    [maxLongitude, minLatitude],
                    [maxLongitude, maxLatitude],
                    [minLongitude, maxLatitude],
                    [minLongitude, minLatitude]
                ]
            ];
            return polygonCoordinates;
        }
    }
    return [];
};
export function isPointInBoundingBox(point, boundingBox) {
    const [lng, lat] = point;
    const [[minLongitude, minLatitude], [maxLongitude, maxLatitude]] = boundingBox;
    return lat >= minLatitude && lat <= maxLatitude && lng >= minLongitude && lng <= maxLongitude;
}
